<template>
  <div class="d-flex">
    <v-autocomplete
      v-model="selectProducts"
      :items="isInitData ? productOptions : products"
      v-bind="$attrs"
      multiple
      return-object
      item-text="name"
      item-value="objectId"
      :loading="isLoading"
      :disabled="isLoading || disabled"
    >
      <template v-slot:selection="{ item, attrs, on }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          :class="`chip-text ${chipColor}`"
          :disabled="disabled"
        >
          {{ item.name }}
        </v-chip>
      </template>
      
      <template v-if="isAppendAction" v-slot:append-outer>
        <template v-if="appendActionType == 'button'">
          <v-btn
            v-if="admin || (employee && employee.enableAddProduct)" 
            color="info"
            style="height: 56px; position: relative; top: -18px;"
            :style="$attrs.dense !== undefined ? 'height: 40px; top: -10px' : 'height: 56px;'"
            @click="isProductDialog = true"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ $t('product.add_product') }}
          </v-btn>
          <v-tooltip v-else top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-btn
                  disabled
                  color="info"
                  style="height: 56px; position: relative; top: -18px;"
                  :style="$attrs.dense !== undefined ? 'height: 40px; top: -10px' : 'height: 56px;'"
                  @click="isProductDialog = true"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('product.add_product') }}
                </v-btn>
              </div>
            </template>
            <span>{{ $t('product.no_permission_to_add_product') }}</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-icon 
            v-if="admin || (employee && employee.enableAddProduct)" 
            @click="isProductDialog = true"
            :disabled="isLoading || disabled"
          >mdi-plus</v-icon>
          <v-tooltip v-else top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-icon disabled>mdi-plus</v-icon>
              </div>
            </template>
            <span>{{ $t('product.no_permission_to_add_product') }}</span>
          </v-tooltip>
        </template>
      </template>
    </v-autocomplete>
    <FormProduct v-model="isProductDialog" @onLoad="initData" :event="`create`" />
  </div>
</template>
<script>
import { Product } from "../classes"
import FormProduct from "./FormProduct.vue";
export default {
  props: {
    value: Array,
    marketId: String,
    projectId: String,
    isCustomSelection: Boolean,
    disabled: Boolean,
    isAppendAction: {
      type: Boolean,
      default: true
    },
    chipColor: {
      type: String,
      default: "primary"
    },
    appendActionType: String,
    products: Array,
    isInitData: Boolean
  },
  components: { FormProduct },
  data() {
    return {
      isLoading: false,
      isProductDialog: false,
      productOptions: [],
      isShow: false
    }
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    selectProducts: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      this.isLoading = true
      try {
        if (this.isInitData){
          this.productOptions = await Product.getProducts({
            projectId: this.projectId
          })
        }
        this.isLoading = false
      } catch (error) {
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
        this.isLoading = false
      }
    },
  }
}
</script>